import { AutogenModelDrsTimecardHist, AutogenRowDrsTimecardHist } from "./autogen/AutogenModelDrsTimecardHist";

export class ModelDrsTimecardHist extends AutogenModelDrsTimecardHist<RowDrsTimecardHist> {
	constructor() {
		super(RowDrsTimecardHist);
	}
}

export class RowDrsTimecardHist extends AutogenRowDrsTimecardHist {
}